// import React, { useState, createContext, useContext, useRef } from "react";

// const searchContext = createContext();

// export function useSearch() {
//   return useContext(searchContext);
// }

// function useSearchProvider() {
//   const icdContainerRef = useRef();
//   const [ICDCode, setICDCode] = useState([]);
//   const [CPTCode, setCPTCode] = useState([]);
//   const [value, setValue] = useState([]);
//   const [diagnosis, setDiagnosis] = useState("");
//   const [order,setOrder]=useState([])

//   return {
//     icdContainerRef,
//     ICDCode,
//     setICDCode,
//     CPTCode,
//     setCPTCode,
//     value,
//     setValue,
//     diagnosis,
//     setDiagnosis,
//     order,
//     setOrder,
//   };
// }

// export function SearchProvider({ children }) {
//   const search = useSearchProvider();
//   return (
//     <searchContext.Provider value={search}>{children}</searchContext.Provider>
//   );
// }
































//test code for preference
import React, { useState, createContext, useContext, useRef, useEffect } from "react";

const searchContext = createContext();

export function useSearch() {
  return useContext(searchContext);
}

const normalizeApiResponse = (response, icdFormat) => {
  const { ner_content } = response;

  let icdCodes = [];
  if (ner_content.data && ner_content.data.length > 0) {
    icdCodes = ner_content.data
      .filter(item => icdFormat === "ICD10-CM" ? item.icd4_code_cm : item.icd4_code_am)
      .map(item => icdFormat === "ICD10-CM" ? item.icd4_code_cm?.[0] || item.icd4_code?.[0] : item.icd4_code_am?.[0] || item.icd4_code?.[0]);
  } else {
    icdCodes = icdFormat === "ICD10-CM" ? ner_content.icd4_cm_codes || ner_content.icd4_codes : ner_content.icd4_am_codes || ner_content.icd4_codes;
  }

  const procedureCodes = (ner_content.pcsData || []).map(item => ({
    pcsDetails: [item.pcs_code, item.description],
    diagnosis: item.rank ? `#${item.rank} ${item.procedure || "Unknown"}` : (item.procedure || "Unknown"),
  }));

  const descArray = ner_content.data
    ? ner_content.data.filter(item => item.placeholder).map(item => item.placeholder)
    : ner_content.entities.map(entity => entity.word);

  return { icdCodes, pcsCodes: procedureCodes, descArray };
};

function useSearchProvider() {
  const icdContainerRef = useRef();
  const [ICDCode, setICDCode] = useState([]);
  const [PCSCode, setPCSCode] = useState([]);
  const [value, setValue] = useState([]);
  const [diagnosis, setDiagnosis] = useState("");
  const [order, setOrder] = useState([]);
  const [rawResponse, setRawResponse] = useState(null);
  const [icdFormat, setIcdFormat] = useState(localStorage.getItem("icdFormat") || "ICD10-CM");

  useEffect(() => {
    if (rawResponse) {
      console.log("Raw Response:", rawResponse);
      const { icdCodes, pcsCodes } = normalizeApiResponse(rawResponse, icdFormat);
      console.log("Normalized Data:", { icdCodes, pcsCodes, icdFormat });
      setICDCode(icdCodes);
      setPCSCode(pcsCodes);
    }
  }, [rawResponse, icdFormat]);

  useEffect(() => {
    localStorage.setItem("icdFormat", icdFormat);
  }, [icdFormat]);

  return {
    icdContainerRef,
    ICDCode,
    setICDCode,
    PCSCode,
    setPCSCode,
    value,
    setValue,
    diagnosis,
    setDiagnosis,
    order,
    setOrder,
    rawResponse,
    setRawResponse,
    icdFormat,
    setIcdFormat,
  };
}

export function SearchProvider({ children }) {
  const search = useSearchProvider();
  return (
    <searchContext.Provider value={search}>{children}</searchContext.Provider>
  );
}